import React from 'react';

import { Container, Grid, Typography } from '@mui/material';

import { Button } from 'components/Elements/Forms/Inputs';
import { useWidth } from 'functions/Hooks/useDeviceDetect';

import { IExtendedBundleIn } from '..';
import flowroutes from '../routes';

interface FooterButtonsProps {
  bundle?: IExtendedBundleIn;
  setBundle?: (bundle: IExtendedBundleIn) => void;
  currentIndex: number;
  handleNext: () => void;
  handlePref: () => void;
}

const FooterButtons: React.FunctionComponent<FooterButtonsProps> = ({
  bundle,
  setBundle,
  currentIndex,
  handleNext,
  handlePref,
}) => {
  const currentWidth = useWidth();

  const handlePrefClick = () => {
    switch (currentIndex) {
      case 3:
        handlePref();
        break;
      case 4:
        if (bundle && setBundle) {
          const tempData = { ...bundle };
          tempData.data_bundle.skip_advice = false;
          setBundle(tempData);
        }
        handlePref();
        break;
      case 5:
        handlePref();
        break;
      default:
        handlePref();
    }
  };

  return (
    <Container maxWidth="md" sx={{}}>
      <Grid
        container
        sx={{
          mb: '35px',
          padding: { xs: 'unset', sm: '0px 15px' },
        }}>
        <Grid item xs={4.5}>
          {flowroutes.at(currentIndex - 1)?.isTransfering == undefined && (
            <Button
              variant="outlined"
              fullWidth={currentWidth === 'xs' ? true : false}
              onClick={() => handlePrefClick()}
              sx={{
                height: '40px',
                minWidth: { xs: 'unset', sm: '150px' },
              }}>
              <Typography sx={{ fontSize: { xs: '16px', sm: '18px' } }}>Vorige</Typography>
            </Button>
          )}
        </Grid>

        <Grid item xs={4.5} container justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            fullWidth={currentWidth === 'xs' ? true : false}
            onClick={() => handleNext()}
            sx={{
              height: '40px',
              minWidth: { xs: 'unset', sm: '150px' },
            }}>
            <Typography sx={{ fontSize: { xs: '16px', sm: '18px' } }}>Volgende</Typography>
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FooterButtons;
